import { combineReducers } from "redux";
import { combineEpics } from "redux-observable";
import { mapValues } from "lodash";

import { wrapEpic } from "lib/utils/epic";

const noop = (x) => x;

export const createDuck = (initialState = null, reducers = {}, epics = [], nestedDucks = {}) => {
  const reducer = (state = initialState, action) => {
    if (reducers[action.type]) {
      state = reducers[action.type](state, action);
    }
    if (reducers._custom) {
      state = reducers._custom(state, action);
    }

    const nestedReducers = {
      ...(reducers._nestedReducers || {}),
      ...mapValues(nestedDucks, (duck) => duck.reducer),
    };

    if (Object.keys(nestedReducers).length > 0) {
      // Code based on https://github.com/reactjs/redux/blob/master/src/combineReducers.js#L146
      let hasChanged = false;
      const nextState = { ...state };
      Object.keys(nestedReducers).forEach((key) => {
        const reducer = nestedReducers[key];
        const previousStateForKey = state[key];
        const nextStateForKey = reducer(previousStateForKey, action);
        if (typeof nextStateForKey === "undefined") {
          throw new Error(`UndefinedStateErrorMessage, key: ${key}, action: ${JSON.stringify(action)}`);
        }
        nextState[key] = nextStateForKey;
        hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
      });
      state = hasChanged ? nextState : state;
    }

    return state;
  };

  const epic = combineEpics(...epics.map(wrapEpic), ...Object.values(nestedDucks).map((duck) => duck.epic));

  return { reducer, epic };
};

export const combineDucks = (ducks) => {
  const reducer = combineReducers(mapValues(ducks, (duck) => duck.reducer));

  const epic = combineEpics(
    ...Object.values(ducks)
      .map((duck) => duck.epic)
      .filter((x) => x != null)
      .map(wrapEpic)
  );

  return { reducer, epic };
};



// WEBPACK FOOTER //
// ./src/lib/utils/duck.js